import { createApp, Transition, TransitionGroup } from "vue";
import App from "./App.vue";
import router from "./router";
import { pinia } from "./pinia";
import helpers from "./helpers";
import { i18n } from "./i18n";
import PrimeVue from "primevue/config";
import "material-icons/iconfont/material-icons.css";
// Import Bootstrap CSS i JS
import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/mindone.css";
import Aura from "@primevue/themes/aura";
import "@/assets/css/custom-primevue.css";
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import "@/assets/js/mindone.js";
import * as Sentry from "@sentry/vue";
import { vPermission } from "@/directives/permission";
import { vSafeHtml } from "@/directives/safeHtml";

// Disable console logs in production for security
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  // Keep console.warn and console.error for important messages
}

const app = createApp(App);

// Inicijalizujte Sentry ODMAH nakon kreiranja app instance
Sentry.init({
  app,
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // U produkciji smanjite na 0.1 (10%)
  // Session Replay
  replaysSessionSampleRate: 0.1, // 10% sesija
  replaysOnErrorSampleRate: 1.0, // 100% sesija sa greškama
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true,
});

app.component("Transition", Transition);
app.component("TransitionGroup", TransitionGroup);

// Register global directives
app.directive("permission", vPermission);
app.directive("safe-html", vSafeHtml);

// Suppress $createElement warnings from vue3-treeselect
app.config.warnHandler = (msg, instance, trace) => {
  if (msg.includes("$createElement")) {
    return;
  }
  console.warn(`[Vue warn]: ${msg}`, trace);
};

app
  .use(pinia)
  .use(router)
  .use(helpers)
  .use(i18n)
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: ".app-dark",
      },
    },
  })
  .mount("#app");
